// 配置下载地址
export default {
  root: process.env.DOWN_ROOT
}



// WEBPACK FOOTER //
// ./src/down/index.js